import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = React.HTMLAttributes<HTMLButtonElement>

function ModalVideoButton({ onClick, children, className }: Props) {
  return (
    <button className={classNames(style.wrapper, className)} onClick={onClick}>
      {children}
    </button>
  )
}

export default ModalVideoButton
